import { useState, useEffect, useContext } from 'react';
import { FetchContext, FetchersContextValue } from '@src/scenario-editor/providers/fetch.context';

// The simplest solution: Pass required dummy arguments for now
export const useFetchByKey = (key: string, valuePath: string, fnParams?: Record<string, unknown>) => {
  const [allData, setAllData] = useState<unknown[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const fetchContext = useContext(FetchContext);

  if (!fetchContext) {
    throw new Error('FetchContext is not provided');
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);

        // Get the specific fetch function
        const fetchFn = fetchContext[key as keyof FetchersContextValue];

        if ([
          'fetchAlternatives',
          'fetchOptionsByMessage',
          'fetchFilteredFitFacts',
          'fetchFilteredArticles'
        ].includes(key)) {
          throw new Error('Fetch function cannot be used with useFetchByKey');
        }

        // Explicitly handle each case based on the function name
        const result = await (fetchFn as (...args: unknown[]) => Promise<{ data: unknown[] }>)(fnParams);
        console.log('>>> result', result);

        setAllData(Array.isArray(result?.data)
          ? result.data.map((item) => (item as Record<string, unknown>)[valuePath])
          : []);
        setIsLoading(false);
      } catch (e) {
        console.error(e);
        setIsLoading(false);
      }
    };

    if (!key || !valuePath) {
      return;
    }

    fetchData().catch(console.error);
  }, [fetchContext, key, valuePath]);

  return [allData, isLoading];
};
